import React from 'react'
import { FuseNavigation } from '@fuse'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import AccessControlMenu from 'app/auth/AccessControlMenu'

function Navigation(props) {
  const navigation = useSelector(({ fuse }) => fuse.navigation)
  const { dense, className, layout = 'vertical' } = props

  return (
    <AccessControlMenu>
      <FuseNavigation
        className={clsx('navigation', className)}
        navigation={navigation}
        layout={layout}
        dense={dense}
      />
    </AccessControlMenu>
  )
}

export default Navigation
